/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Network_Quick_Action_SublineInputs */

const de_home_network_quick_action_subline = /** @type {(inputs: Home_Network_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WLAN-Zuordnung und Status einsehen`)
};

/** @type {(inputs: Home_Network_Quick_Action_SublineInputs) => LocalizedString} */
const en_home_network_quick_action_subline = de_home_network_quick_action_subline;

/**

* @param {Home_Network_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const home_network_quick_action_subline = /** @type {((inputs?: Home_Network_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Network_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_home_network_quick_action_subline(inputs)
	return en_home_network_quick_action_subline(inputs)
});